import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

import SelectDomain from '../../shared/steps/selectdomain'
import SelectDomainConfig from '../../shared/steps/selectdomainconfig'
import PageSlider from '../../shared/pageslider'
import DomainSidebar from '../../shared/sidebar/domainsidebar'

import { EDIT_DOMAIN_PAGE } from '../../../utilities/function/common'

import { getDataFromURL, getPageByURL } from '../../../utilities/function/urlparams'

import { getServiceTypeFromProductConfig } from '../../../utilities/function/configuration'

import { DOMAIN_TYPE } from '../../../utilities/function/servicetype'
import CloseButton from '../../shared/closebutton'
import Loading from "../../shared/loading";

let Domain = (props) => {
    const { location, history } = props
    const [step, setStep] = useState(0)
    const configurations = useSelector(state => state.app.configurations)
    const { deleteDomainNameStatus } = useSelector(state => ({ deleteDomainNameStatus: state.app.deleteDomainNameStatus }))
    const { a, domain, query, config, uuid } = getDataFromURL(location.search)
    const initFlag = useRef(false)

    useEffect(() => {
        if (initFlag.current === false) {
            if (getPageByURL(location.search) === EDIT_DOMAIN_PAGE) {
                if (configurations && Object.keys(configurations).length > 0 && !configurations[uuid]) {
                    history.push(`${history.location.pathname}?a=checkout`)
                }
            }
            initFlag.current = true
        }
    }, [configurations, history, location, uuid])

    const getDomainConfigList = () => {
        const domainConfigList = []
        if (a === 'add' && query) {
            if (domain === 'register' || domain === 'transfer') {
                if (configurations && Object.keys(configurations).length) {
                    Object.keys(configurations).forEach((key) => {
                        if (configurations[key] && !configurations[key].uuid && configurations[key].selectedProduct && configurations[key].selectedProduct.attributes) {
                            const service_type = getServiceTypeFromProductConfig(configurations[key])
                            if (service_type === DOMAIN_TYPE) {
                                if (configurations[key].domainSearchResult) {
                                    domainConfigList.push(configurations[key])
                                }
                            }
                        }
                    })
                }
            }
        } else {
            if (a === 'confdomain' && uuid) {
                if (configurations && Object.keys(configurations).length) {
                    if (configurations[uuid]) {
                        domainConfigList.push(configurations[uuid])
                    }
                }
            }
        }
        return domainConfigList
    }
    const renderSelectDomain = () => {
        return (<SelectDomain/>)
    }
    useEffect(() => {
        if (config && config === 'true') {
            setStep(1)
        } else {
            if (a === 'confdomain') {
                setStep(1)
            } else {
                setStep(0)
            }
        }
    }, [config, a])
    return (
        <div className='of-domain of-page'>
            <div className='of-page__wrapper'>
                <PageSlider step={step}>
                    {renderSelectDomain()}
                    {deleteDomainNameStatus === 'loading'
                        ?
                        <div className={'of-step of-domain-page-slider__step of-select-domain-config'}><Loading/></div>
                        : <SelectDomainConfig domainList={getDomainConfigList()}/>
                    }
                    <CloseButton/>
                </PageSlider>
                <DomainSidebar domainList={getDomainConfigList()}/>
            </div>
        </div>
    )
}

Domain.propTypes = {
    location: PropTypes.any,
    history: PropTypes.any
}

Domain = withRouter(Domain)

export default Domain